import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { VideoGallery } from "./components/VideoGallery";
import { VideoModal } from "./components/VideoModal";
import { useVideoStore } from "../../shared/hooks/useVideoStore";
import { sampleVideos } from "./constants/mock";
import { VideoLayout } from "../../app/layouts/VideoLayout";
import { Header } from "../../shared/components/Header";
import { SideBar } from "../../shared/components/SideBar";

export const VideoPage = observer(() => {
    const videoStore = useVideoStore();
    useEffect(() => {
        videoStore.loadVideos(sampleVideos);
    }, [videoStore]);

    return (
        <VideoLayout header={<Header />} sideBar={<SideBar />}>
            <VideoGallery />
            <VideoModal />
        </VideoLayout>
    );
});
